import React from 'react';

/**
 * QuickFilterChips - Displays quick filter chips for the home page
 * Used for one-click filtering of vehicles and dealers
 */
const QuickFilterChips = ({ activeFilters = [], onFilterToggle }) => {
  const filters = [
    { id: 'availableNow', label: 'Available Now', icon: '⚡' },
    { id: 'mostPopular', label: 'Most Popular Models', icon: '🔥' },
    { id: 'nearMe', label: 'Near Me', icon: '📍' },
    { id: 'topRated', label: 'Top Rated Dealerships', icon: '⭐' },
    { id: 'lowMileage', label: 'Low Mileage', icon: '🎯' },
  ];

  return (
    <div className="flex flex-wrap gap-2">
      {filters.map((filter) => {
        const isActive = activeFilters.includes(filter.id);
        return (
          <button
            key={filter.id}
            onClick={() => onFilterToggle(filter.id)}
            className={`
              px-4 py-2 rounded-xl text-sm font-medium transition-all duration-200
              flex items-center gap-2 whitespace-nowrap
              ${
                isActive
                  ? 'bg-app-accent text-white shadow-lg scale-105'
                  : 'bg-app-bg-secondary-light dark:bg-app-bg-secondary text-app-text-light dark:text-app-text border border-app-border-light dark:border-app-border hover:border-app-accent-light dark:hover:border-app-accent hover:bg-app-accent/10'
              }
            `}
          >
            <span>{filter.icon}</span>
            <span>{filter.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default QuickFilterChips;
